import { useEffect, useState, useRef } from 'react';
import { ClickAwayListener } from '@mui/material';

const CustomFieldPill = ({ customField, onRemove, onValueSelection }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [menuPos, setMenuPos] = useState({ top: 0, left: 0 });
  const wrapperRef = useRef(null);

  const { label, options, selectedOptions: values } = customField;

  const handleMenuToggle = () => {
    if (!isMenuOpen && wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      setMenuPos({ top: rect.bottom + 6, left: rect.left });
    }
    setIsMenuOpen((prev) => !prev);
    setSearchText('');
  };

  const isValueChecked = (item) => values.some((v) => v._id === item._id);

  const handleClickAway = () => { setIsMenuOpen(false); };

  useEffect(() => {
    if (!values.length) { setIsMenuOpen(false); setSearchText(''); }
  }, [values]);

  if (values.length === 0) return null;

  const firstValue = options.find((option) => option._id === values[0]._id) || {};
  const count = values.length;
  const filteredOptions = options.filter((item) =>
    item.label.toLowerCase().includes(searchText.toLowerCase()),
  );

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div className="relative" ref={wrapperRef}>
        <li
          className="relative m-1 bg-white inline-flex items-center justify-center text-[12px] font-medium leading-5 rounded-full px-4 py-1 border border-slate-300 shadow-sm duration-150 ease-in-out cursor-pointer"
          onClick={handleMenuToggle}
        >
          <div className="h-5 flex gap-1 items-center">
            <div>{label} is </div>
            <div>{count > 1 ? `+ ${count}` : firstValue.label}</div>
          </div>
          <img onClick={onRemove} className="text-slate-700 h-5 w-2 ml-2" src="/images/icons/close.svg" style={{ cursor: 'pointer' }} alt="icon" />
        </li>
        {isMenuOpen && (
          <div className="filter-menu" style={{ top: menuPos.top, left: menuPos.left }}>
            <input type="text" value={searchText} onChange={(e) => setSearchText(e.target.value)} placeholder="Search..." className="filter-search-input" />
            <div className="divider" />
            <div className="filter-list max-h-[50vh]">
              {filteredOptions.map((item) => (
                <label key={item._id} className="filter-item">
                  <input className="filter-checkbox" type="checkbox" onChange={() => onValueSelection(item)} checked={isValueChecked(item)} />
                  {item.icon && <div className="w-[20%]">{item.icon}</div>}
                  <div className="w-[90%]">{item.label}</div>
                </label>
              ))}
            </div>
          </div>
        )}
      </div>
    </ClickAwayListener>
  );
};

export default CustomFieldPill;
